export function formatCfgUpdated(iso) {
  if (!iso || typeof iso !== 'string') return 'Not saved yet'
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    })
  } catch {
    return '—'
  }
}

export const PIPELINE_BASECAMP_DAILY_DIGEST = 'basecamp_daily_digest'

export const LLM_PROVIDERS = [
  { id: 'anthropic', label: 'Anthropic' },
  { id: 'openai', label: 'OpenAI' },
  { id: 'gemini', label: 'Gemini' },
]
